import { MouseEvent, TouchEvent, useRef, useState } from 'react';
import { useEvent } from 'react-use';

export const useResize = () => {
  const isDragging = useRef(false);
  const startY = useRef(0);
  const startHeight = useRef(0);

  const [height, setHeight] = useState(300);

  // 공통 리사이징 로직
  const handleResize = (clientY: number) => {
    if (!isDragging.current) return;
    const deltaY = clientY - startY.current;
    const newHeight = Math.min(900, Math.max(100, startHeight.current - deltaY));
    setHeight(newHeight);
  };

  // 마우스 이동 처리
  useEvent('mousemove', (e: MouseEvent) => {
    handleResize(e.clientY);
  });

  // 터치 이동 처리
  useEvent('touchmove', (e: TouchEvent) => {
    if (e.touches.length === 1) {
      handleResize(e.touches[0].clientY);
    }
  });

  // 드래그/터치 종료 처리
  const handleEnd = () => {
    if (!isDragging.current) return;
    isDragging.current = false;
    document.body.style.userSelect = '';
  };

  useEvent('mouseup', handleEnd);
  useEvent('touchend', handleEnd);

  // 공통 시작 로직
  const handleStart = (clientY: number) => {
    isDragging.current = true;
    startY.current = clientY;
    startHeight.current = height;
    document.body.style.userSelect = 'none';
  };

  // 마우스 드래그 시작
  const onMouseDown = (e: MouseEvent) => {
    handleStart(e.clientY);
  };

  // 터치 시작
  const onTouchStart = (e: TouchEvent) => {
    if (e.touches.length === 1) {
      handleStart(e.touches[0].clientY);
    }
  };

  return { height, onMouseDown, onTouchStart };
};
